class AuthActions {
  static AUTHENTICATION = "AUTHENTICATION";
  static AUTHENTICATION_SUCCESSFUL = "AUTHENTICATION_SUCCESSFUL";
  static AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";
  static VERIFICATION_REQUEST = "VERIFICATION_REQUEST";
  static VERIFICATION_SUCCESSFULL = "VERIFICATION_SUCCESSFULL";
  static VERIFICATION_FAILED = "VERIFICATION_FAILED";
  static AUTHENTICATION_VERIFICATION = "AUTHENTICATION_VERIFICATION";

  static CHANGEPASSWORD_REQUEST = "CHANGEPASSWORD_REQUEST";
  static CHANGEPASSWORD_SUCCESSFULL = "CHANGEPASSWORD_SUCCESSFULL";
  static CHANGEPASSWORD_FAILED = "CHANGEPASSWORD_FAILED";

  static LOGOUT = "LOGOUT";

  static authentication() {
    return {
      type: this.AUTHENTICATION
    };
  }
  static authenticationSuccessul(data) {
    return {
      type: this.AUTHENTICATION_SUCCESSFUL,
      data
    };
  }
  static authenticationVerification() {
    return {
      type: this.AUTHENTICATION_VERIFICATION,
    };
  }
  static authenticationFailed(error) {
    return {
      type: this.AUTHENTICATION_FAILED,
      error
    };
  }

  //-----user vericiation
  static userVerificationRequest() {
    return {
      type: this.VERIFICATION_REQUEST
    };
  }
  static userVerificationSuccess(data) {
    return {
      type: this.VERIFICATION_SUCCESSFULL,
      data
    };
  }
  static userVerificationFailed(error) {
    return {
      type: this.VERIFICATION_FAILED,
      error
    };
  }

  //-----user change password
  static userChangePasswordRequest() {
    return {
      type: this.CHANGEPASSWORD_REQUEST
    };
  }
  static userChangePasswordSuccess(data) {
    return {
      type: this.CHANGEPASSWORD_SUCCESSFULL,
      data
    };
  }
  static userChangePasswordFailed(error) {
    return {
      type: this.CHANGEPASSWORD_FAILED,
      error
    };
  }

  static logout() {
    localStorage.removeItem("myData");
    localStorage.clear();
    return {
      type: this.LOGOUT
    };
  }
}

export default AuthActions;
